import { FlightStatusForm } from '@com-delta-idp/mnx-capability-flight-status-ui';
import { FlightStatusAem } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { GenericAction } from '@com-delta-omnichannel/mach';
import { CityCodeResult } from '../models/interface/retrieve-search.interface';

export const adaptStaticContent = (
  aemData?: FlightStatusAem
): FlightStatusForm | null => {
  if (!aemData) {
    return null;
  }

  return {
    inputFields: buildInputFields(aemData),
    errorMessages: adaptErrorMessagesFromAem(aemData),
    orLabel: aemData.orLabel,
    action: { label: '' }, // Empty action instead of mock
    originList: [], // Empty array instead of mock
    destinationList: [], // Empty array instead of mock
    cities: {
      // Empty object with required structure instead of mock
      originCode: '',
      originName: '',
      originRegion: '',
      destinationCode: '',
      destinationName: '',
      destinationRegion: ''
    },
    searchModal: buildSearchModal()
  };
};

const buildInputFields = (
  aemData: FlightStatusAem
): FlightStatusForm['inputFields'] => ({
  departureDate: {
    title: aemData.searchByLabel,
    placeHolder: aemData.searchByLabel,
    floatingLabel: false
  },
  flightNumber: {
    title: aemData.flightNumberLabelFloat,
    placeHolder: aemData.flightNumber,
    floatingLabel: true
  },
  multiRoutePicker: buildMultiRoutePicker(aemData)
});

const buildMultiRoutePicker = (
  aemData: FlightStatusAem
): FlightStatusForm['inputFields']['multiRoutePicker'] => ({
  origin: {
    title: aemData.fromLabel,
    subtitle: aemData.fromLabelFloat
  },
  destination: {
    title: aemData.toLabel,
    subtitle: aemData.toLabelFloat
  },
  ariaLabels: buildAriaLabels(aemData)
});

const buildAriaLabels = (
  aemData: FlightStatusAem
): FlightStatusForm['inputFields']['multiRoutePicker']['ariaLabels'] => {
  return {
    origin: aemData.fromLabelFloat,
    swapArrow:
      aemData.accessibility?.swapAirportsAriaLabel ||
      'Reverse origin and destination city or airport',
    departure: aemData.toLabelFloat
  };
};

const buildSearchModal = (): FlightStatusForm['searchModal'] => ({
  sections: [] // Empty array instead of mock fallback
});

export const predictiveCitiesAdapter = (
  cities: CityCodeResult[]
): GenericAction[] => {
  return cities.map((value) => {
    return {
      id: value.AIRPORT_CODE,
      label: value.CITY_NAME,
      value: `${value.AIRPORT_NAME}`,
      country: value.COUNTRY
    };
  });
};

const adaptErrorMessagesFromAem = (aemData: FlightStatusAem) => {
  const errors: { [key: string]: { [key: string]: string } } = {};

  if (aemData.errorMessages) {
    errors['FLIGHT_NUM_REQD'] = {
      title: 'Error',
      description: aemData.errorMessages.flightNumber.required
    };
    errors['FLIGHT_DATE_REQD'] = {
      title: 'Error',
      description: aemData.errorMessages.departureDate.required
    };
    errors['FROM_CITY_REQD'] = {
      title: 'Error',
      description: aemData.errorMessages.fromCity.required
    };
    errors['TO_CITY_REQD'] = {
      title: 'Error',
      description: aemData.errorMessages.toCity.required
    };
    errors['INVALID_FROMTO'] = {
      title: 'Error',
      description: aemData.errorMessages.sameAirport.invalid
    };
  }

  return errors;
};
